import { render, staticRenderFns } from "./LightTraps.vue?vue&type=template&id=3612de6d&"
import script from "./LightTraps.vue?vue&type=script&lang=js&"
export * from "./LightTraps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports